import * as React from 'react';
import { useForm } from 'react-hook-form';

import { Line } from './Line';

interface BillOfLadingEntry {
  number: string;
  carrierScac?: string;
  shippingLine: string;
}

interface Props {
  onSubmit: (entries: BillOfLadingEntry[]) => Promise<void>;
}

export const AddForm: React.FC<Props> = (props) => {
  const { onSubmit } = props;
  const { register, handleSubmit, setValue, formState, reset } = useForm<BillOfLadingEntry>({
    mode: 'all',
    defaultValues: { number: '', carrierScac: '', shippingLine: '' },
  });

  const submit = handleSubmit(async (data) => {
    const cleanedBol = data;
    if (data.carrierScac === '') {
      delete cleanedBol.carrierScac;
    }
    reset();
    await onSubmit([cleanedBol]);
  });

  register(`carrierScac`, { required: false });
  register(`shippingLine`, { required: true });

  return (
    <form onSubmit={submit}>
      <Line
        bolInputProps={register(`number`, { required: true })}
        onChangeCarrier={(scac, shippingLine) => {
          setValue(`carrierScac`, scac, {
            shouldValidate: true,
            shouldTouch: true,
          });
          setValue(`shippingLine`, shippingLine, {
            shouldValidate: true,
            shouldTouch: true,
          });
        }}
        isValid={formState.isValid}
      />
    </form>
  );
};
AddForm.displayName = 'Shipments.AddContainers.Manual.AddForm';
